export class SVGImage {
  private static SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  private static SVG_URI_PREFIX = 'data:image/svg+xml;charset=utf-8,';

  // Current SVG and elements to be added
  private SVGData: string;
  private SVGElements: string[] = [];

  // Lazy approach to SVG construction
  private SVGDataNew: string;
  private isDirty = true;

  // Dimension of SVG image
  private readonly width: number;
  private readonly height: number;
  private readonly attributes: string;
  private readonly namespace: string;

  constructor(width: number, height: number, attributes: string = '', namespace: string = SVGImage.SVG_NAMESPACE) {
    // Get data
    this.width = width;
    this.height = height;
    this.attributes = attributes;
    this.namespace = namespace;

    // Create basic SVG
    this.SVGData = this.createEmptySVG();
  }

  public setSVGFromString(str: string) {
    this.SVGData = str;
  }

  public getSVGSerialized() {
    let SVGSerialized = this.SVGData.replace('</svg>', '');
    SVGSerialized += this.SVGElements.join('');
    SVGSerialized += '</svg>';
    return SVGSerialized;
  }

  public getSVGUpdateURI() {
    return SVGImage.SVG_URI_PREFIX + this.getSVGUpdateString();
  }

  public getSVGURI() {
    return SVGImage.SVG_URI_PREFIX + this.getSVGString();
  }

  public hasChanged(): boolean {
    return this.isDirty;
  }

  public setBackgroundColor (color: string): void {
    if (this.SVGData.includes('background')) {
      this.SVGData = this.SVGData.replace(/id="background" fill=".*?"/, `id="background" fill="${color}"`);
    } else {
      const background = `<rect x="0" y="0" width="${this.width}" height="${this.height}" id="background" fill="${color}"/>`;
      const position: number = this.SVGData.indexOf('>') + 1;
      this.SVGData = this.SVGData.substring(0, position) + background + this.SVGData.substring(position);
    }

    this.isDirty = true;
  }

  public addLine (x1: number, y1: number, x2: number, y2: number, attributes: string = ''): void {
    const line = `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" ${attributes}/>`;
    this.addElement(line);
  }

  public addCircle (cx: number, cy: number, r: number, attributes: string = ''): void {
    const circle = `<circle cx="${cx}" cy="${cy}" r="${r}" ${attributes}/>`;
    this.addElement(circle);
  }

  public setViewBox(x1: number, x2: number, y1: number, y2: number): void {
    const viewBox = `viewbox="${x1} ${y1} ${x2 - x1} ${y2 - y1}"`;
    if (this.SVGData.includes('viewbox')) {
      this.SVGData = this.SVGData.replace(/viewbox=".*?"/, viewBox);
    } else {
      this.SVGData = this.SVGData.replace(/<svg/, `<svg ${viewBox}`);
    }
  }

  public setWidth(width: number): void {
    this.SVGData = this.SVGData.replace(/width=".*?"/, `width="${width}"`);
  }

  public setHeight(height: number): void {
    this.SVGData = this.SVGData.replace(/height=".*?"/, `height="${height}"`);
  }

  public copy(): SVGImage {
    const copy = new SVGImage(this.width, this.height, this.attributes, this.namespace);
    copy.setSVGFromString(this.getSVGSerialized());
    return copy;
  }

  private getSVGUpdateString() {
    this.constructSVG();
    return this.SVGDataNew;
  }

  private getSVGString() {
    this.constructSVG();
    return this.SVGData;
  }

  private createEmptySVG() {
    let SVGData = `<svg xmlns="${this.namespace}"`;
    SVGData += ` width="${this.width}"`;
    SVGData += ` height="${this.height}"`;
    SVGData += ` ${this.attributes}`;
    SVGData += '></svg>';

    return SVGData;
  }

  private addElement(el: string) {
    this.isDirty = true;
    this.SVGElements.push(el);
  }

  private constructSVG() {
    if (this.isDirty) {
      // Enhance SVG string with new elements
      this.SVGData = this.SVGData.replace('</svg>', '');
      this.SVGData += this.SVGElements.join('');
      this.SVGData += '</svg>';

      // Generate SVG string from new elements
      this.SVGDataNew = this.createEmptySVG();
      this.SVGDataNew = this.SVGDataNew.replace('</svg>', '');
      this.SVGDataNew += this.SVGElements.join('');
      this.SVGDataNew += '</svg>';

      // Remove elements
      this.SVGElements = [];
      this.isDirty = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/SVGImage.ts